export const ISSUES_ENDPOINT = 'issues';
export const ISSUES_PERMISSIONS_ENDPOINT = 'permissions';
export const ISSUES_PERMISSIONS_BULK_OPERATION_ENDPOINT = 'permissions/batch_operation';
export const ISSUES_CURRENT_USER_PERMISSIONS_ENDPOINT = 'users/me';
export const ISSUE_TEMPLATES_ENDPOINT = 'issue-templates';
export const ISSUE_TEMPLATE_CATEGORIES_ENDPOINT = 'issue-template-categories';
export const ISSUE_OSS_OBJECTS_ENDPOINT = 'oss-objects';
export const ISSUES_COMMENTS_ENDPOINT = 'comments';
export const ISSUES_LINKS_ENDPOINT = 'links';
export const ISSUES_ACTIVITIES_ENDPOINT = 'activities';
export const ISSUES_ATTACHMENTS_ENDPOINT = 'attachments';
export const ISSUE_TYPES_ENDPOINT = 'issue-types';
export const ISSUE_SUB_TYPES_ENDPOINT = 'issue-subtypes';
export const ISSUE_TYPES_ENDPOINT_SUB_TYPES = 'subtypes';

export const ISSUE_ROOT_CAUSE_CATEGORIES_ENDPOINT_ROOT_CAUSES = 'rootcauses';
export const ISSUE_ROOT_CAUSE_CATEGORIES_ENDPOINT = 'issue-root-cause-categories';
export const ISSUE_ROOT_CAUSE_ENDPOINT = 'issue-root-causes';

export const ISSUE_ATTRIBUTE_DEFINITIONS_ENDPOINT = 'issue-attribute-definitions';
export const ISSUE_ATTRIBUTE_MAPPINGS_ENDPOINT = 'issue-attribute-mappings';

export const ISSUES_REQUIRED_FIELDS_ENDPOINT = 'fields-metadata';
